/**
 * Read a value from the FE configuration map as a trimmed string.
 *
 * Ops edit these values in Parameter Store, so a key may be missing or hold
 * something that is not a string. Both return `''` rather than throwing, which
 * also lets callers treat "unset" and "set to nothing" the same way.
 */
export const readConfigString = (
  configuration: Record<string, unknown> | null | undefined,
  key: string,
): string => {
  const value = configuration?.[key];

  return typeof value === 'string' ? value.trim() : '';
};
